module.exports = __webpack_public_path__ + "img/error.13d2bd45.svg";